// Centralised, easy-to-evolve configuration for the guided Demo journey.
// Edit STEPS / TAG_LABELS here to reshape the commercial narrative without
// touching UI code. Routes reuse existing screens only — no new data.

// value tags shown on each step: honest source labelling.
export const TAG_LABELS = {
  real: { fr: "Réel", en: "Real" },
  lodge: { fr: "Lodge Data", en: "Lodge Data" },
  sim: { fr: "Simulation", en: "Simulation" },
};

export const TAG_STYLE = {
  real: "border-emerald-300 bg-emerald-50 text-emerald-700",
  lodge: "border-indigo-300 bg-indigo-50 text-indigo-700",
  sim: "border-amber-300 bg-amber-50 text-amber-700",
};

// Situation -> Signaux -> Opportunités -> Actions -> Campagne -> Résultats
export const DEMO_JOURNEY = [
  {
    id: "overview", route: "/dashboard", tag: "real",
    title: { fr: "Vue d’ensemble", en: "Overview" },
    value: {
      fr: "Situez le marché en un coup d’œil : volumes réels et tendance. Lodge & Co transforme des données dispersées en une lecture claire.",
      en: "Grasp the market at a glance: real volumes and trend. Lodge & Co turns scattered data into one clear read.",
    },
  },
  {
    id: "market", route: "/markets?market=FR-MRU", tag: "real",
    title: { fr: "Marché", en: "Market" },
    value: {
      fr: "Explorez le marché réel France → Maurice : signaux aériens ADI, saisonnalité et origines. La preuve par la donnée observée.",
      en: "Explore the real France → Mauritius market: ADI air signals, seasonality and origins. Proof through observed data.",
    },
  },
  {
    id: "opportunities", route: "/opportunities", tag: "lodge",
    title: { fr: "Opportunités", en: "Opportunities" },
    value: {
      fr: "Lodge & Co dérive des opportunités priorisées à partir des signaux — où concentrer l’effort commercial.",
      en: "Lodge & Co derives prioritised opportunities from the signals — where to focus commercial effort.",
    },
  },
  {
    id: "action-center", route: "/dashboard", tag: "lodge",
    title: { fr: "Action Center", en: "Action Center" },
    value: {
      fr: "Chaque opportunité devient une action recommandée, concrète et contextualisée. De l’insight à la décision.",
      en: "Each opportunity becomes a concrete, contextualised recommended action. From insight to decision.",
    },
  },
  {
    id: "campaign", route: "/campaigns#demo-campaign", tag: "sim",
    title: { fr: "Campagne exemple", en: "Sample campaign" },
    value: {
      fr: "Visualisez une campagne illustrative déclenchée depuis une action. Exemple simulé pour montrer le passage à l’exécution.",
      en: "See an illustrative campaign triggered from an action. Simulated example showing the move to execution.",
    },
  },
  {
    id: "performance", route: "/performance#demo-report", tag: "sim",
    title: { fr: "Rapport de performance", en: "Performance report" },
    value: {
      fr: "Bouclez la chaîne avec un rapport de résultats simulé : la valeur mesurée qui justifie l’abonnement.",
      en: "Close the loop with a simulated results report: the measured value that justifies the subscription.",
    },
  },
];

// Prefer the real France -> Mauritius market when present; never fall back to
// France -> World if Mauritius is available. Returns the chosen market value
// or null when no Mauritius market exists (caller keeps its current value).
export function pickDefaultMarket(markets) {
  if (!Array.isArray(markets) || markets.length === 0) return null;
  const isMauritius = (m) =>
    m &&
    (m.value === "FR-MRU" ||
      m.value === "FR-MU" ||
      (/^FR$/i.test(m.origin || "") && /^(MRU|MU)$/i.test(m.destination || "")) ||
      /(maurice|mauritius)/i.test(m.label || ""));
  const mu = markets.find(isMauritius);
  return mu ? mu.value : null;
}
